// extracted by mini-css-extract-plugin
module.exports = {"Status":"Status_Status__22Ml4","loading":"Status_loading__ROcFF"};